import { getNotificationLogs } from "../../store/api/notification";
import store from "../../store/store";
import { NOTIFICATION_STATUS } from "../constants/constants";

export function preprocessNotifications(notifications: any) {
    // group notifications by the message body
    const groupedNotifications: any = {};
    const unseenStatus = [NOTIFICATION_STATUS.PENDING, NOTIFICATION_STATUS.DELIVERED, NOTIFICATION_STATUS.SENT];
    let hasUnseen: boolean = false;

    notifications?.forEach((notification: any) => {
        const { body } = notification?.messageId;

        // If this body hasn't been added, create a new entry
        if (!groupedNotifications[body]) {
            groupedNotifications[body] = {
                ...notification,
                relatedNotifications: []
            };
        }

        // Add the current notification to the related notifications list
        groupedNotifications[body].relatedNotifications.push(notification);

        if(!hasUnseen && unseenStatus.includes(notification?.status)) {
            hasUnseen = true;
        }
    });

    // Convert the object to an array 
    const uniqueNotifications = Object.values(groupedNotifications);
    uniqueNotifications.sort((a: any, b: any) => new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime());
    return {
        processedNotifications: uniqueNotifications, 
        hasUnseen: hasUnseen,
    };
}

export function generateUpdateNotificationStatusPayload(processedNotifications: any[], currentStatus: string[], newStatus: string) {
    const notifications: any = [];

    processedNotifications?.forEach((processedNotification: any) => {
        processedNotification?.relatedNotifications?.forEach((notification: any) => {
            if (currentStatus.includes(notification.status)) {
                notifications.push({ _id: notification._id, status: newStatus });
            }
        })
    }
    );

    return {
        notifications: notifications,
    };
}

export async function fetchNotifications(partyId: string, channelType: string = "", eventType: string = "", status: string = ""){
    const reqSearchParams = {
        partyId: partyId,
        channelType: channelType,
        eventType: eventType,
        status: status,
    }
    return store.dispatch(getNotificationLogs(reqSearchParams)).unwrap();
}